import React from 'react'
import { GroupsOutlined } from '@mui/icons-material'
import { AutocompleteChangeReason, AutocompleteInputChangeReason } from '@mui/material'
import { ComboBox } from 'components/common'
import { Company } from 'models'
import { entityDisplayName } from 'utils/helpers'
import { NavBarSellerFamily } from './NavBarSellerFamily'

type FamilySelectorProps = {
  isLoginB2C: boolean
  selectedParent: Company | null
}

const FamilySelector: React.FC<FamilySelectorProps> = ({ isLoginB2C, selectedParent }) => {
  const b2cOptions = React.useMemo(() => (selectedParent ? [selectedParent] : []), [selectedParent])

  const handleReadOnlySelection = React.useCallback(
    (_event: React.SyntheticEvent, _value: Company | null, _reason: AutocompleteChangeReason) =>
      undefined,
    [],
  )

  const handleReadOnlyInput = React.useCallback(
    (_event: React.SyntheticEvent, _value: string, _reason: AutocompleteInputChangeReason) =>
      undefined,
    [],
  )

  return (
    <>
      <GroupsOutlined className="ml-3" />
      {!isLoginB2C ? (
        <NavBarSellerFamily />
      ) : (
        <ComboBox
          id="seller-parent-b2c"
          options={b2cOptions}
          getOptionLabel={(option: Company) => entityDisplayName(option, true)}
          getOptionKey={(option: Company) => option.id}
          selectedOption={selectedParent}
          onSelection={handleReadOnlySelection}
          onInputChange={handleReadOnlyInput}
          disabled
        />
      )}
    </>
  )
}

export { FamilySelector }
